<app-modal-component [open]="open" label="Edit message">
  <div class="cf__dialog">
    <app-form-wrapper [title]="'Edit message ' + msgNo" (iconClick)="close()" icon="cancel">
      <form [formGroup]="messagesForm" (submit)="$event.preventDefault()">
        <div class="cf__body">
          <div class="cf__row">
            <!-- sender id -->
            <input-field label="Sender ID">
              <bk-select
                formControlName="senderId"
                [options]="senderIDs"
                valueKey="senderId"
                variant="sender"
                noun="sender ID"
                placeholder="Choose a sender ID"
                emptyText="No sender IDs available"
              />
            </input-field>

            <!-- message subject -->
            <input-field label="Subject">
              <input
                type="text"
                id="cf-edit-subject"
                class="input-style"
                placeholder="For example, Fee reminder, first notice"
                autocomplete="off"
                formControlName="subject"
              />
            </input-field>
          </div>

          <!-- Message body -->
          <div>
            <input-field label="Message">
              <div class="cf__compose">
                <textarea
                  #messageTextarea
                  name="body"
                  id="cf-edit-body"
                  rows="6"
                  class="input-style"
                  placeholder="Type the SMS your recipients will get"
                  formControlName="body"
                ></textarea>
                <message-attribute-menu (select)="appendAttribute(messageTextarea, $event)"></message-attribute-menu>
              </div>

              <message-attribute-chips
                [message]="messagesForm.controls['body'].value"
                (remove)="removeAttribute($event)"
              ></message-attribute-chips>
            </input-field>

            <div class="cf__meter">
              <span>
                @if (parts.estimated) {
                  About
                }
                <strong>{{ parts.length }}</strong>
                @if (parts.parts <= 1) {
                  of {{ parts.perPart }} characters
                } @else {
                  characters
                }
                · <strong>{{ parts.parts || 0 }}</strong> {{ parts.parts === 1 ? "part" : "parts" }}
              </span>
              @if (parts.parts && audience.count !== null) {
                <span>
                  ≈ <strong>{{ formatCount(parts.parts * audience.count) }}</strong> SMS each time it sends
                </span>
              }
              @if (unicodeNote) {
                <p class="cf__meter-note">{{ unicodeNote }}</p>
              }
            </div>
            <p class="bk-sr-only" aria-live="polite">{{ partsAnnouncement }}</p>
            <p class="cf__hint">
              <strong>Insert contact attribute</strong> (the &#123; &#125; button beside the message) adds a contact
              field such as <code>{{ "{{firstName}}" }}</code>, filled in for each recipient.
            </p>
          </div>
        </div>

        <!-- footer -->
        <div class="cf__foot">
          <button type="button" class="bk-btn bk-btn--ghost" (click)="previewMessage()">
            <span class="bk-sym" aria-hidden="true">smartphone</span>
            Preview and test
          </button>
          <div class="cf__foot-end">
            <button type="button" class="bk-btn bk-btn--ghost" (click)="close()">Cancel</button>
            <button
              type="button"
              class="bk-btn bk-btn--primary"
              [disabled]="!messagesForm.valid"
              (click)="handleSaveMessage()"
            >
              Save changes
            </button>
          </div>
        </div>
      </form>
    </app-form-wrapper>
  </div>
</app-modal-component>
